// extracted by mini-css-extract-plugin
export var container = "_4p-0";
export var error = "_4p-9";
export var label = "_4p-5";
export var light = "_4p-6";
export var md = "_4p-3";
export var sm = "_4p-2";
export var thin = "_4p-8";
export var thinBold = "_4p-7";
export var vertical = "_4p-4";
export var xs = "_4p-1";